import apiClient from "../../../../../../services/apiClient";


export const apiActions = {
  getQueueHistory: async (params) => {
    const linkGet = 'q_history?' + params.join('&');
    return await apiClient.get(linkGet);
  },

  getPersonalStatistics: async (params) => {
    const linkGet = 'stat_personal_kg?' + params.join('&');
    return await apiClient.get(linkGet);
  }
  
};